const selectCourierFromState = state => state.courier;

export const selectCourierLoadingFromState = state =>
  selectCourierFromState(state).loading;

export const selectCourierApiErrorFromState = state =>
  selectCourierFromState(state).apiError;

export const selectCourierZonesFromState = state =>
  selectCourierFromState(state).zones;
export const selectCourierZonesCountFromState = state =>
  selectCourierFromState(state).zonesCount;

export const selectCourierCentersFromState = state =>
  selectCourierFromState(state).centers;
export const selectCourierCentersCountFromState = state =>
  selectCourierFromState(state).centersCount;

export const selectCouriersFromState = state =>
  selectCourierFromState(state).couriers;
export const selectCouriersCountFromState = state =>
  selectCourierFromState(state).couriersCount;

export const selectCourierRoundsFromState = state =>
  selectCourierFromState(state).rounds;
export const selectCourierRoundsCountFromState = state =>
  selectCourierFromState(state).roundsCount;

export const selectCourierRoundStopsFromState = state =>
  selectCourierFromState(state).roundStops;

export const selectCourierRoundSchedulesFromState = state =>
  selectCourierFromState(state).roundSchedules;
export const selectCourierRoundSchedulesCountFromState = state =>
  selectCourierFromState(state).roundSchedulesCount;

export const selectCourierShiftsFromState = state =>
  selectCourierFromState(state).shifts;
export const selectCourierShiftsCountFromState = state =>
  selectCourierFromState(state).shiftsCount;

export const selectCourierTripsFromState = state =>
  selectCourierFromState(state).trips;
export const selectCourierTripsCountFromState = state =>
  selectCourierFromState(state).tripsCount;

export const selectCourierTripTasksFromState = state =>
  selectCourierFromState(state).tripTasks;

export const selectEligibleCouriersFromState = state =>
  selectCourierFromState(state).eligibleCouriers;

export const selectCourierCustodyItemsFromState = state =>
  selectCourierFromState(state).custodyItems;

export const selectCourierReportsListFromState = state =>
  selectCourierFromState(state).reportsList;
export const selectCourierReportFromState = state =>
  selectCourierFromState(state).report;
export const selectCourierLiveMonitorFromState = state =>
  selectCourierFromState(state).liveMonitor;
